import React from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { Line } from "react-chartjs-2";
import { MoreVertical } from "react-feather";

import {
  Card as MuiCard,
  CardContent,
  CardHeader,
  IconButton,
} from "@mui/material";
import { spacing } from "@mui/system";
import { alpha } from "@mui/material/styles";

const Card = styled(MuiCard)(spacing);

const ChartWrapper = styled.div`
  height: 378px;
`;

function LineChart({ theme, monthlyStats = [] }) {
  // Process monthlyStats to get chart data
  const labels = monthlyStats.map(
    (stat) => `${stat.month.substring(0, 3)} ${stat.year}`
  );
  const bookingsData = monthlyStats.map((stat) => stat.totalBookings);
  const confirmedData = monthlyStats.map((stat) => stat.confirmedBookings);

  // Fallback to static data if no monthlyStats provided
  const fallbackLabels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const fallbackBookingsData = [12, 15, 18, 22, 25, 30, 28, 32, 35, 40, 38, 42];
  const fallbackConfirmedData = [
    10, 12, 15, 18, 20, 25, 22, 28, 30, 35, 32, 38,
  ];

  const data = {
    labels: labels.length > 0 ? labels : fallbackLabels,
    datasets: [
      {
        label: "Total Bookings",
        fill: true,
        backgroundColor: function (context) {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null;
          }

          const gradient = ctx.createLinearGradient(0, 0, 0, 300);
          gradient.addColorStop(0, alpha(theme.palette.secondary.main, 0.0875));
          gradient.addColorStop(1, "rgba(0, 0, 0, 0)");

          return gradient;
        },
        borderColor: theme.palette.secondary.main,
        tension: 0.4,
        data: bookingsData.length > 0 ? bookingsData : fallbackBookingsData,
      },
      {
        label: "Confirmed Bookings",
        fill: true,
        backgroundColor: "transparent",
        borderColor: theme.palette.success.main,
        borderDash: [4, 4],
        tension: 0.4,
        data: confirmedData.length > 0 ? confirmedData : fallbackConfirmedData,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(0,0,0,0.0)",
        },
      },
      y: {
        grid: {
          color: "rgba(0,0,0,0.0375)",
          fontColor: "#fff",
        },
      },
    },
  };

  return (
    <Card mb={6}>
      <CardHeader
        action={
          <IconButton aria-label="settings" size="large">
            <MoreVertical />
          </IconButton>
        }
        title="Event Trends"
      />
      <CardContent>
        <ChartWrapper>
          <Line data={data} options={options} />
        </ChartWrapper>
      </CardContent>
    </Card>
  );
}
export default withTheme(LineChart);
